import * as React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export default function AssignmentsSectionSkeleton() {
  return (
    <div className="space-y-6 p-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-40" />
        <Skeleton className="h-8 w-20 rounded-lg" />
      </div>

      {/* Assignment List Items */}
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className="border rounded-lg p-4 bg-card dark:bg-gray-900 space-y-3"
          >
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-1/2" />
            <div className="flex justify-end">
              <Skeleton className="h-6 w-16 rounded-md" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
